import React, { Suspense } from 'react';
import { useLocation } from 'react-router-dom';

import LoadingScreen from '../../components/LoadingScreen';

const MissionsListComponent = React.lazy(() => import('./components/MissionsList'));

const MissionsList = () => {
  const { pathname } = useLocation();
  return (
    <div>
      <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')} />}>
        <MissionsListComponent />
      </Suspense>
    </div>
  );
};

export default MissionsList;
